export default __webpack_public_path__ + "static/media/placeholder.26bc3836.svg";